module.exports = __webpack_public_path__ + "static/media/foto2.6bec1a88.png";